import React from 'react';

const CompanyLogoMobile = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.737"
      height="35.473"
      viewBox="0 0 36.737 35.473"
      {...props}
    >
      <title>The Mom Project</title>
      <g transform="translate(0 0)">
        <path
          fill="currentColor"
          d="M192.882,437.742h2.678V402.268h-7.874l-10.5,13.854-10.5-13.854h-7.872v35.473h2.836V404.789h2.729l12.8,16.322,12.962-16.322h2.729Z"
          transform="translate(-158.823 -402.268)"
        />
        <path
          fill="currentColor"
          d="M192.594,439.988,179.16,423.194v30.277H182.1V431.434l10.5,13.383,10.5-13.383v22.038h3.1V423.037Z"
          transform="translate(-174.226 -417.998)"
        />
      </g>
    </svg>
  );
};

export default CompanyLogoMobile;
